<template>
    <div :data-toggle-extended="`${extended}`">
        <span class="toggle-text" :class="{'toggle-extended': extended, 'active': necessary }">
            <span v-if="!necessary" ref="phrase"><slot></slot></span>
            <span class="first" ref="first"></span>
            <span class="second" ref="second"></span>
        </span>
        <span class="toggle-text-controls" v-if="necessary">
            <span v-if="!extended" class="dots">...</span>
            <a v-if="!this.url" @click="extended = !extended">{{ extended ? $t('global_viewLess') : $t('global_viewMore') }}</a>
            <a v-else="" :href="this.url">{{ $t('global_viewMore') }}</a>
        </span>
    </div>
</template>

<script>


    export default {
        name: 'ReadEvenMore',

        props: {
            max: { type: Number },
            desktop: { type: Number },
            mobile: { type: Number },
            mobileResolution: { type: Number, default: 767 },
            url: { type: String },
        },

        data() {
            return {
                extended: false,
                necessary: false,
                clone: null,
            };
        },

        computed: {
            maxLength() {
                // Checking $resize will make the whole expression reactive, updating it on resize
                return this.$resize && ((this.$mq.above(this.mobileResolution) ? this.desktop : this.mobile) || this.max || 0);
            },
            baseElement() {
                return this.$refs.phrase;
            },
            firstChunk() {
                return this.$refs.first;
            },
            secondChunk() {
                return this.$refs.second;
            },
        },
        methods: {
            splitContents: function () {
                // Do we actually need to split ?
                this.necessary = this.clone.textContent.trim().length > this.maxLength;

                this.firstChunk.innerHTML = '';
                this.secondChunk.innerHTML = '';

                // Replace with original contents
                if ( this.necessary === false ) {
                    this.baseElement.innerHTML = this.clone.innerHTML;
                    return false;
                }
                this.baseElement.innerHTML = '';

                let currentLength = 0;
                let currentChunk = this.firstChunk;
                this.clone.childNodes.forEach(child => {
                    // Element nodes
                    if (child.nodeType === 1) {
                        currentLength += child.textContent.length;
                        if (currentLength > this.maxLength) {
                            currentChunk = this.secondChunk;
                        }
                        currentChunk.appendChild(child.cloneNode(true));
                    }
                    // Text nodes
                    else if (child.nodeType === 3) {
                        const text = child.nodeValue.trim();
                        const canFit = this.maxLength - currentLength;

                        // If the text fits or if we're already past the cutoff, we just append the node
                        if (text.length <= canFit || currentChunk === this.secondChunk) {
                            currentChunk.appendChild(child.cloneNode());
                        }
                        // Otherwise we will split the text into two parts
                        else {
                            // We need to split at the last word that still fits
                            // So we get the last space up to this point
                            const splitPoint = text.lastIndexOf(' ', canFit);
                            if (splitPoint === -1) {
                                // If we found no spaces, then we're dealing with a big-ass word
                                currentChunk = this.secondChunk;
                                currentChunk.appendChild(document.createTextNode(' ' + text + ' ' ));
                            } else {
                                currentChunk.appendChild(document.createTextNode(' ' + text.substring(0, splitPoint) + ' ' ));
                                currentChunk = this.secondChunk;
                                currentChunk.appendChild(document.createTextNode(' ' + text.substring(splitPoint) + ' ' ));
                            }
                        }

                        currentLength += text.length;
                    }
                });
            }
        },
        mounted(){

            this.clone = this.baseElement.cloneNode(true);

            window.addEventListener("resize", this.splitContents, { passive: true });

            this.splitContents();

        }
    }
</script>
